import { useQuery, } from "react-query";
import DataService from '../../../config/DataServices'

const { getRequest } = DataService()

export const useCoreAddressList = ({ page, size, searchText, sortOrder, sortField }) => {

    return useQuery({
        queryKey: ["core-address-list", page, size, searchText, sortOrder, sortField],
        queryFn: () => {
            return getRequest(`/core-address-bal?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}`)
        }
    })
}


export const DepositHistory = ({ page, size, sortOrder, searchText, sortField, type, currency, network }) => {

    return useQuery({
        queryKey: ["transfer-history", page, size, searchText, sortOrder, type, currency, network],
        queryFn: () => {
            return getRequest(`/core-txn-list?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}&currency=${currency}&network=${network}`)
        }
    })
}

export const WithdrawHistory = ({ page, size, searchText, sortOrder, sortField, type, currency, network }) => {

    return useQuery({
        queryKey: ["transfer-history", page, size, searchText, sortOrder, sortField, type, currency, network],
        queryFn: () => {
            return getRequest(`/core-txn-list?page=${page}&size=${size}&search=${searchText}&sortOrder=${sortOrder}&sortField=${sortField}&type=${type}&network=${network}`)
        }
    })
}